
import { bidDetailsActionTypes } from './action-types'

export const initialState = {
  routesById: {},
  routeDetailsByRouteId: {},
  repliesByRouteId: {},
  routeDetailsLoading: false,
  pendingProposalCount: 0,
  rules: '',
  observation: '',
}
export const bidDetails = (state = initialState, { type, payload }) => {
  switch (type) {
    case bidDetailsActionTypes.FETCH_ROUTES_BY_ID: {
      const { routes = [], rules = '', observation = '', bidId, ...rest } = payload
      return {
        ...state,
        routesById: {
          ...state.routesById,
          [bidId]: {
            routes,
            rules,
            observation,
            ...rest,
          },
        },
      } }
    case bidDetailsActionTypes.FETCH_ROUTE_DETAILS_BY_ID: {
      const { routeDetails, routeId } = payload
      return {
        ...state,
        routeDetailsByRouteId: {
          ...state.routeDetailsByRouteId,
          [routeId]: routeDetails,
        },
      } }
    case bidDetailsActionTypes.ROUTE_DETAILS_IS_LOADING:
      return {
        ...state,
        routeDetailsLoading: payload,
      }
    case bidDetailsActionTypes.SET_PENDING_PROPOSAL_COUNT:
      return {
        ...state,
        pendingProposalCount: payload,
      }
    case bidDetailsActionTypes.INCREMENT_PENDING_PROPOSAL_COUNT:
      return {
        ...state,
        pendingProposalCount: state.pendingProposalCount + 1,
      }
    case bidDetailsActionTypes.FETCH_REPLIES_BY_TRANSPORTER:
      return {
        ...state,
        repliesByRouteId: {
          ...state.repliesByRouteId,
          [payload.routeId]: payload.replies,
        },
      }
    default:
      return state
  }
}
